import PropTypes from 'prop-types';

import { fieldClasses } from '#globalComponents/Forms/fieldStyles';

export default function TextInput({ error = false, className = '', type = 'text', ...props }) {
	return (
		<input type={type} className={fieldClasses('h-10 rounded-card px-4', Boolean(error), className)} {...props} />
	);
}

TextInput.propTypes = {
	error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	className: PropTypes.string,
	type: PropTypes.string,
};
